import React from 'react';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

const useStyles = makeStyles(theme => ({
  listItem: {
    display: 'list-item',
    marginLeft: theme.spacing(4),
    listStyle: 'disc',
    paddingLeft: theme.spacing(1),
    paddingTop: 0,
    paddingBottom: 0
  },
  stepsContainer: {
    margin: theme.spacing(2, 0),
  },
}));

export default function AddToCartNextSteps() {
  const title = t('acceptDesignScreen.addToCartNextSteps.title');
  const steps = Object.values(t('acceptDesignScreen.addToCartNextSteps.steps'));
  const classes = useStyles();

  return (
    <div className={classes.stepsContainer}>
      <Typography component="div">{title}</Typography>
      <List dense>
        {steps.map((step, key) => (
          <ListItem key={key} className={classes.listItem}>
            <ListItemText
              primary={step}
              primaryTypographyProps={{
                variant: 'body1'
              }}
            />
          </ListItem>
        ))}
      </List>
    </div>
  );
};
